import attributionService from '../api/attribution.js'

// initial state
const state = {
  // STORAGE KEYS
  sessionStorageKey: 'sessionStorageKey',
  urlStorageKey: 'urlStorageKey',
  userAgentStorageKey: 'userAgentStorageKey',
  layoutIdStorageKey: 'layoutIdStorageKey',
  // VARS
  sessionId: '',
  url: '',
  userAgent: '',
  layoutId: '',

  // STORAGE KEYS
  attributionIdStorageKey: 'attributionIdStorageKey',
  attributionOrganicStoreDownloadURLsStorageKey: 'attributionOrganicStoreDownloadURLsStorageKey',
  attributionPlatformStorageKey: 'attributionPlatformStorageKey',
  attributionStoreDownloadURLsStorageKey: 'attributionStoreDownloadURLsStorageKey',
  // VARS
  attributionId: '',
  attributionPlatform: 'ios',
  storeAttributionUrls: {},
  organicStoreAttributionUrls: {},

  attributionStatus: 'todo',
}

// getters
const getters = {
  sessionId: state => { return state.sessionId },
  url: state => { return state.url },
  userAgent: state => { return state.userAgent },
  layoutId: state => { return state.layoutId },

  attributionStatus: state => { return state.attributionStatus },
  attributionId: state => { return state.attributionId },
  attributionPlatform: state => { return state.attributionPlatform },
  storeAttributionUrls: state => { return state.storeAttributionUrls },
  organicStoreAttributionUrls: state => { return state.organicStoreAttributionUrls },

  sessionStorageKey: state => { return state.sessionStorageKey },
  urlStorageKey: state => { return state.urlStorageKey },
  userAgentStorageKey: state => { return state.userAgentStorageKey },
  layoutIdStorageKey: state => { return state.layoutIdStorageKey },

  attributionIdStorageKey: state => { return state.attributionIdStorageKey },
  attributionOrganicStoreDownloadURLsStorageKey: state => { return state.attributionOrganicStoreDownloadURLsStorageKey },
  attributionPlatformStorageKey: state => { return state.attributionPlatformStorageKey },
  attributionStoreDownloadURLsStorageKey: state => { return state.attributionStoreDownloadURLsStorageKey },
}

// mutations
const mutations = {
  ['SESSION_ID_SET'] (state, sessionId) { state.sessionId = sessionId },
  ['URL_SET'] (state, url) { state.url = url },
  ['USER_AGENT_SET'] (state, userAgent) { state.userAgent = userAgent },
  ['LAYOUT_ID_SET'] (state, layoutId) { state.layoutId = layoutId },

  ['ATTRIBUTION_STATUS_SET'] (state, attributionStatus) { state.attributionStatus = attributionStatus },
  ['ATTRIBUTION_ID_SET'] (state, attributionId) { state.attributionId = attributionId },
  ['ATTRIBUTION_PLATFORM_SET'] (state, attributionPlatform) { state.attributionPlatform = attributionPlatform },
  ['ATTRIBUTION_URLS_SET'] (state, urls) {
    state.storeAttributionUrls = urls.storeUrls
    state.organicStoreAttributionUrls = urls.organicStoreUrls
  },
}

// actions
const actions = {
  ['ATTRIBUTION'] ({commit, state}, payload) {
    if (['progress','done'].includes(state.attributionStatus)) { return }
    commit('ATTRIBUTION_STATUS_SET', 'progress')

    return attributionService.postAttribution(payload)
      .then((response) => {
        commit('ATTRIBUTION_STATUS_SET', 'done')
        commit('ATTRIBUTION_ID_SET', response.attribution_id)
        commit('ATTRIBUTION_PLATFORM_SET', response.platform)
        commit('ATTRIBUTION_URLS_SET', { storeUrls: response.store_download_urls, organicStoreUrls: response.organic_store_download_urls })
        return Promise.resolve(response)
      })
      .catch((error) => Promise.reject(error))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
